import React, { useEffect, useState, useContext } from 'react'
import DataTable from 'react-data-table-component'
import Loader from './Spinner'
import debounce from 'lodash.debounce'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom'
import { AuthContext } from './../../Auth/AuthContext'
import { useLocation } from 'react-router'
import { EMPTY } from './../../graphql/Auth/auth'
import { useMutation } from '@apollo/client'
import { CSVLink } from 'react-csv'
import withReactContent from 'sweetalert2-react-content'
import { useHistory } from 'react-router-dom'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import { Check } from 'lucide-react'
import DatePickerInput from './DatePickerInput'

//Const Regex
const regExpFormFields = new RegExp('/catalog/forms/\\d/fields+$')

const defaultCheckbox = React.forwardRef(({ onClick, ...rest }, ref) => {
  return (
    <>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          ref={ref}
          onClick={onClick}
          {...rest}
        />
        <label className="form-check-label" id="check" />
      </div>
    </>
  )
})

export const LayoutTable = ({
  data = [],
  title,
  showCardHeader = true,
  subHeaderComponentClassName = 'row',
  gql = EMPTY,
  requery = EMPTY,
  extraRefetchDelete = null,
  refetchFunctionQueries = async () => {},
  exportQuery = EMPTY,
  importQuery = EMPTY,
  maximumFilesImport = 1,
  specialImportRoute = false,
  importMessageValidation = 'Archivos necesarios',
  editText = <i className="fas fa-edit"></i>,
  detailsText = 'Detalles',
  hideDetails = false,
  hideActions = false,
  actionBtnEdit = false,
  actionBtnDetails = false,
  sizeProductName = '300px',
  hideBtnEdit = false,
  actionBtnErase = false,
  hideBtnDelete = false,
  changeCustomActionErase = false,
  platformSelector = false,
  paginationServer = true,
  totalCount,
  pagePagination,
  setPagePagination,
  mutationAction = false,
  hideFilterBar = false,
  FilterBarPlaceholder = false,
  filterBarValue = '',
  loadingData,
  handleButton,
  actionsAddProducts = false,
  handleButtonRowCondition = false,
  handleButtonClassName = '',
  handleButtonTitle = 'Action',
  handleButtonType = 'button',
  headersButtons = true,
  exportImportButton = true,
  alertAction = false,
  alertActionText = '',
  addBtnTxt,
  filter = false,
  filterOptions = [],
  filterOptionsSecond = [],
  filterOptionsThird = [],
  filterOptionsFourth = [],
  filterOptionsFifth = [],
  filterOptionsSix = [],
  filterOnChange = () => {},
  filterOnChangeSecond = () => {},
  filterOnChangeThird = () => {},
  filterOnChangeFourth = () => {},
  filterOnChangeFifth = () => {},
  filterOnChangeSix = () => {},
  filterDefaultOptionText = false,
  filterDefaultOptionTextSecond = false,
  filterDefaultOptionTextThird = false,
  filterDefaultOptionTextFourth = false,
  filterDefaultOptionTextFifth = false,
  filterDefaultOptionTextSix = false,

  defaultValueSelectSecond = false,
  defaultValueSelectThird = false,
  defaultValueSelectFourth = false,
  defaultValueSelectFifth = false,
  defaultValueSelectSix = false,

  filterLabelText = false,
  filterLabelTextSecond = false,
  filterLabelTextThird = false,
  filterLabelTextFourth = false,
  filterLabelTextFifth = false,
  filterLabelTextSix = false,
  filterSecond = false,
  filterThird = false,
  filterFourth = false,
  filterFifth = false,
  filterSix = false,

  filterTypeSelect = 'select',
  filterTypeSelectSecond = 'select',
  filterTypeSelectThird = 'select',
  filterTypeSelectFourth = 'select',
  filterTypeSelectFifth = 'select',
  filterTypeSelectSix = 'select',

  extraHeaderText,
  extraHeaderButtonTo = '',
  extraHeaderButton,
  hideId = false,
  titleActions = 'Acciones',
  withCard = true,
  extraArgHandleButton = null,
  handleButtonModal = () => {},
  handleButtonModalText = false,
  expandableRows = false,
  expandableRowsComponent = <div></div>,
  alertColor = '#ffd281',
  listFormat = false,
  hidePagination = false,
  defaultValueSelect = false,

  handleButtonSecond = false,
  handleButtonSecondTitle = '',
  noDataComponent = 'Sin información',
  extraHeaderButtonFunction = false,
  extraHeaderButtonFunctionText = 'Función',
  filterLabelDate = 'Fecha salida',
  filterOnChangeDate = false,
  hideAddNew = false,
  showAddNewButton = false,
  showSwitchFilter = false,
  showSwitchFilterChecked = false,
  handleAddNewButton = () => {},
  handleAddNewButtonTxt = '',
  handleShowSwitchFilter = () => {},
  showSwitchFilterTxt = 'Switch',
  wrapFlag = true,
  filterChoosen = false,

  isFilterRangeShow = false,
  filterRangeProps = null,

  headerComponents = null,
  classCardBody = 'card-body',
  customHeaderComponent = null,
  configCustomCols = null,
  flagGrowCustom = false,
  dense = false,
  // onRowClicked = () => {},
  // onRowDoubleClicked = () => {},
  clearSelectedRows = false,
  selectableRows = false,
  onSelectedRowsChange = () => {},
  selectableRowSelected = () => {},
  selectableRowsComponent = defaultCheckbox,
  selectableRowsComponentProps = {},
  selectableRowsNoSelectAll = false,
  selectableRowsVisibleOnly = false,
  rowDisabledCriteria = (row) => {},
  paginationServerOptions = {
    persistSelectedOnSort: true,
    persistSelectedOnPageChange: true,
  },
  accions_custom_title = 'Acciones',

  cols_search = 'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
  cols_search_div = null,
  cols_filters = 'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
  cols_filters_div = null,
  cols_filter_range_show = 'row col-12 d-flex flex-wrap mb-3',
  exportOnClick = false,
  titleExportOnClick = <i className="fas fa-cloud-download-alt"></i>,
  extraButtonsExport = null,
}) => {
  const history = useHistory()
  const [columns, setColumns] = useState([])
  const [cell, setCell] = useState([])
  const [dataExported, setDataExported] = useState([])
  const [FileNameExported, setFileNameExported] = useState('')
  const [loadingExport, setLoadingExport] = useState(false)
  const [loadingImport, setLoadingImport] = useState(false)
  const location = useLocation()
  const [permissions, setPermissions] = useState({
    create: false,
    edit: false,
    erase: false,
    exportBtn: false,
    importBtn: false,
    permissionsBtn: false,
    rolPermissionsMoodulesBtn: false,
    cycleCountcycleOperationBtn: false,
    path: '',
  })
  const MySwal = withReactContent(Swal)

  const animatedComponents = makeAnimated()

  const {
    create,
    edit,
    erase,
    exportBtn,
    importBtn,
    permissionsBtn,
    rolPermissionsMoodulesBtn,
    cycleCountcycleOperationBtn,
    path,
  } = permissions
  const { user } = useContext(AuthContext)

  const [deleteItem] = useMutation(gql)

  const [exportItems] = useMutation(exportQuery)
  const [importItems] = useMutation(importQuery)

  //SET PERMISSIONS
  useEffect(() => {
    const permissions = user?.userPermissions
    let listPermissions = []

    permissions.map((item) => {
      let moduleName = `${item?.module_info?.relative_link}`

      if (moduleName === location.pathname) {
        return (listPermissions = {
          create: item.access_retrieve,
          edit: item.access_edit,
          erase: item.access_delete,
          exportBtn: item.access_export,
          importBtn: item.access_import,
          path: item.module_info.relative_link,
        })
      }

      if (
        moduleName === '/catalog/forms/:formId?/fields' &&
        regExpFormFields.test(location.pathname)
      ) {
        return (listPermissions = {
          create: item.access_retrieve,
          edit: item.access_edit,
          erase: item.access_delete,
          exportBtn: item.access_export,
          importBtn: item.access_import,
          path: location.pathname,
        })
      }

      return null
    })

    permissions.map((item) => {
      let submoduleName = item.submodule_info?.relative_link
      if (submoduleName) {
        if (location.pathname.includes('new')) {
          const relativePath = location.pathname
            .split('new')[0]
            .replace(/.$/, '')
          const relativePathSplit = relativePath.split('/')
          const submodulePath = relativePathSplit[relativePathSplit.length - 1]
          if (submoduleName === `/${submodulePath}`) {
            return (listPermissions = {
              create: item.access_retrieve,
              edit: item.access_edit,
              erase: item.access_delete,
              exportBtn: item.access_export,
              importBtn: item.access_import,
              path: `${item.module_info.relative_link}/${submodulePath}`,
            })
          }
        }
        if (location.pathname.includes('edit')) {
          const relativePath = location.pathname
            .split('edit')[0]
            .replace(/.$/, '')
          const relativePathSplit = relativePath.split('/')
          const submodulePath = relativePathSplit[relativePathSplit.length - 1]
          if (submoduleName === `/${submodulePath}`) {
            return (listPermissions = {
              create: item.access_retrieve,
              edit: item.access_edit,
              erase: item.access_delete,
              exportBtn: item.access_export,
              importBtn: item.access_import,
              path: `${item.module_info.relative_link}/${submodulePath}`,
            })
          }
        }
        const relativePathSplit = location.pathname.split('/')
        const submodulePath = relativePathSplit[relativePathSplit.length - 1]
        if (submoduleName === `/${submodulePath}`) {
          return (listPermissions = {
            create: item.access_retrieve,
            edit: item.access_edit,
            erase: item.access_delete,
            exportBtn: item.access_export,
            importBtn: item.access_import,
            path: `${item.module_info.relative_link}/${submodulePath}`,
          })
        }
      }
      return true
    })
    if (
      location.pathname === '/catalog/users' ||
      location.pathname === '/ticket/types'
    ) {
      const checkBtnPermissions = permissions.some((permission) => {
        if (
          permission?.module_info.name === 'UsersPermissions' ||
          permission?.module_info.name === 'TicketTypesPermissions'
        ) {
          if (permission?.access_read) {
            return true
          } else {
            return false
          }
        }
        return null
      })
      listPermissions.permissionsBtn = checkBtnPermissions
    }

    if (location.pathname === '/catalog/roles') {
      const checkBtnPermissions = permissions.some((permission) => {
        if (permission?.module_info.name === 'RolePermissionsModulesDefault') {
          if (permission?.access_read) return true
          else return false
        }
        return null
      })
      listPermissions.rolPermissionsMoodulesBtn = checkBtnPermissions
    }

    if (location.pathname === '/inventories/cycleCountRequest') {
      const checkBtnCycleCountcycleOperation = permissions.some(
        (permission) => {
          if (permission?.submodule_info?.name === 'CycleCountcycleOperation') {
            return permission?.access_read ? true : false
          }
          return null
        }
      )
      listPermissions.cycleCountcycleOperationBtn =
        checkBtnCycleCountcycleOperation
    }

    return setPermissions(listPermissions)
  }, [location.pathname, user])

  //SETTING DATA
  useEffect(() => {
    let columns = []
    setCell(data)
    if (data.length === 0) return
    Object.keys(data[0]).map((item, index) => {
      if (item === 'id') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          width: '80px',
          omit: hideId,
          wrap: wrapFlag,
        })
      }
      if (item.toLowerCase().includes('__omit')) {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: false,
          omit: true,
          wrap: wrapFlag,
        })
      }
      if (item === 'alert') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          omit: true,
          wrap: wrapFlag,
        })
      }
      if (item === 'orderIdRoutesForm') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          omit: true,
          wrap: wrapFlag,
        })
      }

      if (item === 'órdenes de compra') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
        })
      }
      if (item === 'item_code') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          omit: true,
          wrap: wrapFlag,
        })
      }
      if (item === 'Progreso') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => (
            <div
              className="progress"
              style={{ backgroundColor: '#E5E7EB', width: '100%' }}
            >
              <div
                className={`progress-bar progress-bar-striped progress-bar-animated`}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{
                  width: `${row[item]?.props?.status?.progress}%`,
                  backgroundColor: '#4BB543',
                }}
              >
                &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
              </div>
            </div>
          ),
          sortable: false,
          width: '180px',
          wrap: wrapFlag,
        })
      }
      if (item === 'expandable') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          omit: true,
          wrap: wrapFlag,
        })
      }
      if (item === 'orderShippingId') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          omit: true,
          wrap: wrapFlag,
        })
      }
      //Para mostrar la imagen en el catalogo de productos para agregar en nuevo pedido
      if (item === 'img_url') {
        return columns.push({
          name: 'Imagen',
          cell: (row) => (
            <>
              <div className="text-center w-100 my-1">
                <img
                  src={row[item]}
                  style={{ maxWidth: '100%', maxHeight: '100px' }}
                  alt="ordersImages"
                />
              </div>
            </>
          ),
          wrap: wrapFlag,
        })
      }
      //Para poder seleccionar la cantidad del producto a agregar en nuevo pedido
      if (item === 'quantity_select') {
        return columns.push({
          name: 'Cantidad',
          width: '150px',
          cell: (row) => {
            // let limite = row[item] > 5 ? 5 : row[item];
            // let array = []
            // for(let i = 0; i < limite; i++){
            //   array.push(i)
            // }

            return (
              <>
                <div id="principal" className="text-center w-100 my-1">
                  {/* <select id={`select-quantity-${row["sku"]}`} name="select-quantity" className="form-control" onChange={(e)=>{row["quantity_selectioned"] = parseInt(e.target.value)}}>
                  {array.map((item, index)=><option key={index}>{item + 1}</option>)}
                </select> */}
                  <input
                    type="number"
                    className="form-control"
                    placeholder={row[item] + ' máximo'}
                    onChange={(e) => {
                      row['quantity_selectioned'] = parseInt(e.target.value)
                    }}
                  />
                </div>
              </>
            )
          },
          wrap: wrapFlag,
        })
      }
      //Para que el nombre del producto se visualice correctamente en nuevo pedido
      if (item === 'product_add') {
        return columns.push({
          name: 'nombre',
          width: sizeProductName,
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
        })
      }

      if (item === 'gestor') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          wrap: wrapFlag,
          grow: configCustomCols ? configCustomCols[item]?.grow ?? null : null,
          center: configCustomCols
            ? configCustomCols[item]?.center ?? null
            : null,
        })
      }

      if (item === 'tickets') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          //wrap: wrapFlag,
          //grow: 0,
          sortable: true,
          grow: configCustomCols ? configCustomCols[item]?.grow ?? null : null,
          center: configCustomCols
            ? configCustomCols[item]?.center ?? null
            : null,
        })
      }

      if (item === 'ciudadano' || item === 'Categoría') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          //grow: growCustom ? growCustom[item] ?? null : null,
          width: '140px',
        })
      }

      if (
        item === 'Fecha inicio' ||
        item === 'acciones' ||
        item === 'Subcategoría' ||
        item === 'estatus' ||
        item === 'Fecha de creación'
      ) {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          //grow: growCustom ? growCustom[item] ?? null : null,
          width: '60px',
        })
      }

      if(item === 'Trámite' || item == 'Fecha') 
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          //grow: growCustom ? growCustom[item] ?? null : null,
          width: '160px',
        })
      
      if(item === 'Estatus')
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          //grow: growCustom ? growCustom[item] ?? null : null,
          width: '180px',
        })

      if (item === 'Fecha de finalización') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          //grow: growCustom ? growCustom[item] ?? null : null,
          width: '180px',
        })
      }

      if (item === 'dirección') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          //grow: growCustom ? growCustom[item] ?? null : null,
          width: '350px',
        })
      }

      if (item === 'acciones') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          //grow: growCustom ? growCustom[item] ?? null : null,
          width: '160px',
          // right: true,
        })
      }

      if (item === 'Relación') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          //grow: growCustom ? growCustom[item] ?? null : null,
          width: '120px',
        })
      }

      if (item == 'Check') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          //grow: growCustom ? growCustom[item] ?? null : null,
          width: '90px',
        })
      }

      if (item === 'Zona') {
        return columns.push({
          name: toTitleCase(item),
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          //grow: growCustom ? growCustom[item] ?? null : null,
          width: '180px',
        })
      }

      if (hideActions && item === 'accions_custom') {
        return columns.push({
          name: accions_custom_title,
          //title: 'Acciones',
          selector: (row) => row[item],
          sortable: true,
          wrap: wrapFlag,
          button: true,
          width: '230px',
        })
      }

      if (flagGrowCustom) {
        if (
          item === Object.keys(configCustomCols).find((key) => key === item)
        ) {
          return columns.push({
            name: toTitleCase(item),
            selector: (row) => row[item],
            wrap: wrapFlag,
            grow: configCustomCols
              ? configCustomCols[item]?.grow ?? null
              : null,
            center: configCustomCols
              ? configCustomCols[item]?.center ?? null
              : null,
          })
        }
      }

      return columns.push({
        name: toTitleCase(item),
        selector: (row) => row[item],
        sortable: true,
        wrap: wrapFlag,
        //grow: growCustom ? growCustom[item] ?? null : null,
      })
    })

    if (!hideActions) {
      columns.push({
        name: titleActions,
        button: true,
        width: !cycleCountcycleOperationBtn ? '200px' : '230px',
        cell: (row) => (
          <>
            <div className={'my-3 d-flex flex-column accionesp'}>
              <div className="d-flex" style={{ gap: '5px' }}>
                {handleButtonSecond && (
                  <span
                    className="btn btn-migrates btn-sm"
                    onClick={() => handleButtonSecond(row['id'], row)}
                  >
                    {handleButtonSecondTitle}
                  </span>
                )}

                {handleButton ? (
                  <>
                    {handleButtonType === 'checkbox' ? (
                      <>
                        <input
                          id={row['id'] + '-checkBoxLay'}
                          type="checkbox"
                          onClick={() => handleButton(row['id'])}
                        ></input>
                      </>
                    ) : (
                      <>
                        {/* Span */}
                        <span
                          className={`btn btn-migrates btn-sm ${handleButtonClassName}`}
                          onClick={() =>
                            handleButton(row['id'], extraArgHandleButton)
                          }
                        >
                          {handleButtonTitle}
                        </span>
                      </>
                    )}
                  </>
                ) : !hideDetails &&
                  !handleButton &&
                  !handleButtonRowCondition &&
                  !actionBtnDetails ? (
                  <Link
                    className="btn btn-migrates btn-sm"
                    to={`${path}/details/${row['id']}/show`}
                  >
                    {detailsText}
                  </Link>
                ) : (
                  actionBtnDetails && (
                    <>
                      <span
                        className="btn btn-migrates btn-sm"
                        onClick={() => actionBtnDetails(row)}
                      >
                        {detailsText}
                      </span>
                    </>
                  )
                )}

                {!hideBtnEdit ? (
                  edit &&
                  !handleButton &&
                  !handleButtonRowCondition &&
                  !actionBtnEdit ? (
                    <Link
                      className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                      to={`${path}/edit/${row['id']}`}
                      title="Editar"
                    >
                      {editText}
                    </Link>
                  ) : (
                    actionBtnEdit &&
                    edit && (
                      <span
                        className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                        onClick={() => actionBtnEdit(row['id'], row)}
                        title="Editar"
                      >
                        {editText}
                      </span>
                    )
                  )
                ) : (
                  <></>
                )}

                {cycleCountcycleOperationBtn && handleButtonModalText && (
                  <button
                    className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                    onClick={() => handleButtonModal(row['id'])}
                  >
                    <i className="fas fa-play"></i>
                  </button>
                )}

                {!actionBtnErase &&
                !handleButton &&
                !handleButtonRowCondition &&
                !hideBtnDelete &&
                !changeCustomActionErase &&
                erase ? (
                  <button
                    type="button"
                    className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                    onClick={() => handleDelete(row['id'])}
                    title="Eliminar"
                  >
                    <i className="fas fas fa-trash"></i>
                  </button>
                ) : (
                  actionBtnErase &&
                  !hideBtnDelete &&
                  erase && (
                    <button
                      type="button"
                      className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                      onClick={() => actionBtnErase(row['id'])}
                      title="Eliminar"
                    >
                      <i className="fas fas fa-trash"></i>
                    </button>
                  )
                )}
                {permissionsBtn && !handleButton && !handleButtonRowCondition && (
                  <Link
                    className="btn btn-warning btn-migrates-cover btn-sm"
                    to={`${path}/permissions/edit/${row['id']}`}
                  >
                    <i className="fas fa-lock"></i>
                  </Link>
                )}
                {rolPermissionsMoodulesBtn &&
                  !handleButton &&
                  !handleButtonRowCondition &&
                  row['condition_show_permission_of_role__omit'] && (
                    <Link
                      className="btn btn-warning btn-migrates-cover btn-sm"
                      to={`${path}/${row['id']}/permissionsModules`}
                    >
                      <i className="fas fa-lock"></i>
                    </Link>
                  )}
                {row.alert &&
                  alertAction &&
                  edit &&
                  !handleButton &&
                  !handleButtonRowCondition && (
                    <Link
                      className="btn btn-migrates btn-sm"
                      to={`${path}/refill/${row['id']}`}
                    >
                      {alertActionText}
                    </Link>
                  )}
                {row.alert &&
                  alertAction &&
                  edit &&
                  handleButton &&
                  handleButtonRowCondition && (
                    <Link
                      className="btn btn-migrates btn-sm buttonWithoutSpace"
                      to={`${path}/refill/${row['id']}`}
                    >
                      {alertActionText}
                    </Link>
                  )}
              </div>
            </div>
          </>
        ),
        wrap: true,
      })
    } else if (actionsAddProducts) {
      columns.push({
        name: titleActions,
        button: true,
        width: '100px',
        cell: (row) => (
          <>
            <div
              className={
                handleButton && handleButtonRowCondition
                  ? 'btn-group btn-actions-table noGap'
                  : 'btn-group btn-actions-table'
              }
            >
              {handleButton && (
                <>
                  <span
                    className={`btn btn-migrates btn-md ${handleButtonClassName}`}
                    onClick={() => handleButton(row, extraArgHandleButton)}
                  >
                    {handleButtonTitle}
                  </span>
                </>
              )}
            </div>
          </>
        ),
        wrap: true,
      })
    }
    setColumns(columns)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    data,
    edit,
    erase,
    permissionsBtn,
    rolPermissionsMoodulesBtn,
    cycleCountcycleOperationBtn,
    path,
    loadingExport,
    loadingImport,
    dataExported,
    loadingData,
  ])

  //PAGINATION OPTIONS DATA TABLE
  const Options = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    // selectAllRowsItem: true,
    // selectAllRowsItemText: 'Todos',
  }

  const conditionalRowStyles = [
    {
      when: (row) => row.alert,
      style: {
        backgroundColor: alertColor,
      },
    },
  ]

  const handleDelete = async (id) => {
    MySwal.fire({
      showCloseButton: true,
      icon: 'warning',
      title: '¿Estas seguro de eliminar el registro?',
      html: (
        <>
          <div className="message-container">Esta accion es permanente</div>
        </>
      ),
      allowOutsideClick: false,
      buttonsStyling: false,
      showDenyButton: true,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (requery) {
            await deleteItem({
              variables: {
                id: parseInt(id),
                userId: parseInt(user.idUser),
              },
              refetchQueries: [
                {
                  query: requery,
                  variables: { ...pagePagination },
                },
                extraRefetchDelete && { ...extraRefetchDelete },
              ],
            })
          } else {
            await deleteItem({
              variables: {
                id: parseInt(id),
                userId: parseInt(user.idUser),
              },
            })
            await refetchFunctionQueries()
          }
          return toastSweetAlert({
            mode: 'ok',
            message: 'Registro ha sido eliminado',
          })
        } catch (error) {
          toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }
      }
    })
  }

  //LOGIC FOR FILTER DATA
  const handleSearch = (value) => {
    const query = value.target.value.toLowerCase()
    if (!query) {
      setCell(data)
    }
    setPagePagination({
      ...pagePagination,
      searchQuery: query,
    })
  }

  //LOGIC DATA PAGINATION
  const handlePageChange = (page) => {
    if (!paginationServer) return
    if (mutationAction) {
      localStorage.setItem('limit', 10)
      localStorage.setItem(
        'offset',
        parseInt(localStorage.getItem('limit')) * (page - 1)
      )

      // setPagePaginationMutation({
      //   limit: 10,
      //   offset: 0,
      //   searchQuery: pagePaginationMutation?.searchQuery,
      //   platform: pagePaginationMutation?.platform,
      // })
      mutationAction()
      return
    }
    setPagePagination({
      ...pagePagination,
      offset: pagePagination.limit * (page - 1),
    })
  }

  const handlePerRowsChange = async (newPerPage) => {
    if (!paginationServer) return
    if (mutationAction) {
      localStorage.setItem('limit', newPerPage)

      // setPagePaginationMutation({
      //   ...pagePaginationMutation,
      //   limit: newPerPage,
      // })
      mutationAction()
      return
    }
    setPagePagination({ ...pagePagination, limit: newPerPage })
  }

  const getDataToExport = async () => {
    try {
      const dataExported = await exportItems()
      const nameOperation = exportQuery.definitions[0].name.value

      const camelCaseNameOperation =
        nameOperation.charAt(0).toLowerCase() + nameOperation.slice(1)

      const fileName = nameOperation.slice(6)
      setFileNameExported(fileName)
      setDataExported(dataExported.data[`${camelCaseNameOperation}`])

      document.getElementById('exportfileCSV').click()

      setLoadingExport(false)
      return toastSweetAlert({
        mode: 'ok',
        message: 'CSV Generado',
      })
    } catch (error) {
      setLoadingExport(false)
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const importCSVData = async () => {
    try {
      document.getElementById('importfileCSV').click()
    } catch (error) {
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleFileCSV = async (e) => {
    try {
      if (!e.target.files[0]) {
        return
      }
      for (const file of e.target.files) {
        if (file.type !== 'text/csv')
          return toastSweetAlert({
            mode: 'error',
            message: 'Solo se admiten archivos CSV',
          })
      }
      if (e.target.files.length < maximumFilesImport) {
        return toastSweetAlert({
          mode: 'error',
          message: `Esta importación requiere mínimo de ${maximumFilesImport} ${
            maximumFilesImport > 1 ? 'documentos.' : 'documento.'
          }
          Archivos necesarios: ${importMessageValidation}
          `,
        })
      }

      if (e.target.files.length > maximumFilesImport) {
        return toastSweetAlert({
          mode: 'error',
          message: `Esta importación admite un máximo de ${maximumFilesImport} ${
            maximumFilesImport > 1 ? 'documentos.' : 'documento.'
          }
          Archivos necesarios: ${importMessageValidation}
          `,
        })
      }

      // const validate = await fileValidator(e.target.files[0], 'all')

      // if (!validate) {
      //   return toastSweetAlert({
      //     mode: 'error',
      //     message: 'Solo se admite CSV',
      //   })
      // }
      setLoadingImport(true)
      toastSweetAlert({
        mode: 'loading',
        message: 'Cargando información, espere...',
      })
      await importItems({
        variables: {
          files: e.target.files,
        },
      })
      setLoadingImport(false)
      return toastSweetAlert(
        {
          mode: 'ok',
          message: 'La importación se hizo correctamente',
        },
        history.push(window.location.pathname)
      )
    } catch (error) {
      setLoadingImport(false)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const disableDates = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const yyyy = today.getFullYear()
    return `${yyyy}-${mm}-${dd}`
  }

  //Funcion para devolver un elemento html de tipo select o selectMultiple
  const handleFilterSelect = ({ typeSelect, nameFilter }) => {
    let labelText = ''
    let options = []
    let onChange = () => {}
    let defaultSelect = false
    let defaultOptionText = false

    switch (nameFilter) {
      case 'filter':
        labelText = filterLabelText
        options = filterOptions
        onChange = filterOnChange
        defaultSelect = defaultValueSelect
        defaultOptionText = filterDefaultOptionText
        break
      case 'filterSecond':
        labelText = filterLabelTextSecond
        options = filterOptionsSecond
        onChange = filterOnChangeSecond
        defaultSelect = defaultValueSelectSecond
        defaultOptionText = filterDefaultOptionTextSecond
        break

      case 'filterThird':
        labelText = filterLabelTextThird
        options = filterOptionsThird
        onChange = filterOnChangeThird
        defaultSelect = defaultValueSelectThird
        defaultOptionText = filterDefaultOptionTextThird
        break

      case 'filterFourth':
        labelText = filterLabelTextFourth
        options = filterOptionsFourth
        onChange = filterOnChangeFourth
        defaultSelect = defaultValueSelectFourth
        defaultOptionText = filterDefaultOptionTextFourth
        break

      case 'filterFifth':
        labelText = filterLabelTextFifth
        options = filterOptionsFifth
        onChange = filterOnChangeFifth
        defaultSelect = defaultValueSelectFifth
        defaultOptionText = filterDefaultOptionTextFifth
        break

      case 'filterSix':
        labelText = filterLabelTextSix
        options = filterOptionsSix
        onChange = filterOnChangeSix
        defaultSelect = defaultValueSelectSix
        defaultOptionText = filterDefaultOptionTextSix
        break
    }

    if (typeSelect === 'select') {
      return (
        <div className={cols_filters}>
          {labelText && <label htmlFor={nameFilter}>{labelText}</label>}
          <select
            id={nameFilter}
            name={nameFilter}
            type="select"
            className="input-field form-control position-searchInput"
            placeholder="Selecciona una opción"
            onChange={onChange}
            defaultValue={defaultSelect ? defaultSelect : ''}
          >
            <option value="" readOnly={defaultSelect} disabled={defaultSelect}>
              {defaultOptionText ? defaultOptionText : 'Todos'}
            </option>
            {options.map((option) => option)}
          </select>
        </div>
      )
    }

    if (typeSelect === 'selectMultiple') {
      return (
        <div className={cols_filters}>
          {labelText && <label htmlFor={nameFilter}>{labelText}</label>}
          <Select
            id={nameFilter}
            name={nameFilter}
            closeMenuOnSelect={true}
            components={animatedComponents}
            placeholder={`${
              defaultOptionText ? defaultOptionText : 'Selecciona opción(es)'
            }`}
            NoOptionsMessage="Sin resultados"
            isMulti={true}
            options={options}
            onChange={(e) => onChange(e)}
            menuPosition="auto"
            value={defaultSelect}
          />
        </div>
      )
    }
  }

  function toTitleCase(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  return (
    <div
      className={`${withCard && 'card'} layout-configs ${
        loadingImport ? 'processing-file' : ''
      }`}
    >
      {showCardHeader && (
        <div className={`${withCard && 'card-header pt-3'}`}>
          <h3 className="card-title pl-3">{title}</h3>
          <div className="control-btn-box pr-3">
            <div
              className="btn-group actions-btn"
              role="group"
              aria-label="Button group with nested dropdown"
            >
              <div className="btn-group" role="group">
                {headersButtons && exportBtn && exportOnClick && (
                  <>
                    <button
                      id="exportOnClick"
                      // type="button"
                      className="btn btn-purple btn-sm"
                      onClick={exportOnClick}
                    >
                      {titleExportOnClick}
                    </button>
                    {extraButtonsExport && extraButtonsExport}
                  </>
                )}
                {exportImportButton &&
                  headersButtons &&
                  (importBtn || exportBtn) &&
                  (exportQuery !== EMPTY || importQuery !== EMPTY) && (
                    <>
                      <button
                        id="btnGroupDrop1"
                        type="button"
                        className="btn btn-purple btn-sm"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        disabled={loadingExport}
                      >
                        <i className="fas fa-cloud-download-alt"></i>
                      </button>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="btnGroupDrop1"
                      >
                        <>
                          {exportBtn && exportQuery !== EMPTY && (
                            <>
                              <CSVLink
                                id="exportfileCSV"
                                filename={FileNameExported}
                                data={dataExported}
                                className="hide"
                              ></CSVLink>
                              <span
                                className="dropdown-item pointer"
                                onClick={getDataToExport}
                              >
                                <i className="fas fa-file-export"></i>{' '}
                                &nbsp;Exportar CSV
                              </span>
                            </>
                          )}
                          {importBtn && specialImportRoute ? (
                            <>
                              <span
                                className="dropdown-item pointer"
                                onClick={history.push(specialImportRoute)}
                              >
                                <i className="fas fa-file-import"></i>{' '}
                                &nbsp;Importar CSV
                              </span>
                            </>
                          ) : (
                            importBtn &&
                            importQuery !== EMPTY && (
                              <>
                                <input
                                  type="file"
                                  id="importfileCSV"
                                  className="hide"
                                  onChange={(e) => handleFileCSV(e)}
                                  multiple={
                                    maximumFilesImport > 1 ? true : false
                                  }
                                  accept={'.csv'}
                                />
                                <span
                                  className="dropdown-item pointer"
                                  onClick={importCSVData}
                                >
                                  <i className="fas fa-file-import"></i>{' '}
                                  &nbsp;Importar CSV
                                </span>
                              </>
                            )
                          )}
                        </>
                      </div>
                    </>
                  )}
              </div>

              {create && headersButtons && !hideAddNew && (
                <Link to={`${path}/new`} className="btn btn-purple btn-sm">
                  <i className="fa fa-plus"></i>{' '}
                  {addBtnTxt ? addBtnTxt : 'Agregar nuevo'}
                </Link>
              )}

              {showAddNewButton && (
                <button
                  type="button"
                  className="btn btn-purple btn-sm"
                  onClick={handleAddNewButton}
                >
                  {handleAddNewButtonTxt
                    ? handleAddNewButtonTxt
                    : 'Agregar nuevo'}
                </button>
              )}

              {showSwitchFilter && (
                <label className="d-flex justify-content-start align-items-center m-0">
                  <div className="checkbox mr-2">
                    <input
                      type="checkbox"
                      // checked={filters.evidence}
                      onChange={handleShowSwitchFilter}
                      className="switch-filter mt-1"
                      checked={showSwitchFilterChecked}
                    />
                  </div>
                  <span>{showSwitchFilterTxt}</span>
                </label>
              )}

              {create && headersButtons && extraHeaderButton && (
                <Link
                  to={extraHeaderButtonTo}
                  className="btn btn-purple btn-sm"
                >
                  {extraHeaderText}
                </Link>
              )}
              {create && headersButtons && extraHeaderButtonFunction && (
                <span
                  onClick={extraHeaderButtonFunction}
                  className="btn btn-purple btn-sm"
                >
                  {extraHeaderButtonFunctionText}
                </span>
              )}

              {headerComponents && headerComponents}
            </div>
          </div>
        </div>
      )}

      <div className={classCardBody}>
        <div
          className={`${
            listFormat
              ? 'hidePagination'
              : hidePagination && cell.length < 10
              ? 'hidePagination'
              : ''
          }`}
        >
          <DataTable
            columns={columns}
            data={cell}
            expandOnRowClicked
            expandableRows={expandableRows}
            expandableRowsComponent={expandableRowsComponent}
            fixedHeader
            fixedHeaderScrollHeight="600px"
            highlightOnHover
            pagination
            paginationComponentOptions={Options}
            pointerOnHover
            // responsive
            striped
            subHeader={
              hideFilterBar &&
              !filter &&
              !filterSecond &&
              !filterOnChangeDate &&
              !customHeaderComponent
                ? false
                : true
            }
            subHeaderAlign="left"
            subHeaderWrap
            conditional
            // actions={
            //   platformSelector && (
            //     <div className="platform-selector">
            //       <div className="row">
            //         <div className="col-s6 mr-3">
            //           <i className="fa fa-filter"></i>
            //         </div>
            //         <div className="col-s6">
            //           <select
            //             className="form-control"
            //             type="select"
            //             onChange={(e) =>
            //               setPagePagination({
            //                 ...pagePagination,
            //                 platform: parseInt(e.target.value),
            //               })
            //             }
            //           >
            //             <option value="" disabled>
            //               Selecciona una opción
            //             </option>
            //             <option value="">Todas</option>
            //             <option value="1">Woocomerce</option>
            //             <option value="2">MercadoLibre</option>
            //             <option value="3">Amazon</option>
            //           </select>
            //         </div>
            //       </div>
            //     </div>
            //   )
            // }
            subHeaderComponent={
              <div
                id="headerFilters"
                className={subHeaderComponentClassName}
                style={{
                  justifyContent:
                    hideFilterBar && filter ? 'end' : 'space-between',
                }}
              >
                {isFilterRangeShow && (
                  <div className={cols_filter_range_show}>
                    {filterRangeProps?.selectTypes && (
                      <div className="mr-3">
                        <span htmlFor={filterRangeProps?.selectTypes?.id}>
                          {filterRangeProps?.selectTypes?.label ??
                            'Campo de fecha:'}
                        </span>
                        <div className="d-flex">
                          <select
                            id={filterRangeProps?.selectTypes?.id}
                            className={`form-control rounded-2`}
                            onChange={filterRangeProps?.selectTypes?.onChange}
                            value={filterRangeProps?.selectTypes?.value ?? ''}
                            placeholder={
                              filterRangeProps?.selectTypes?.placeholder ?? ''
                            }
                          >
                            <option value={''}>Seleccione una opción</option>
                            <>
                              {filterRangeProps.selectTypes.options.length >
                              0 ? (
                                filterRangeProps.selectTypes.options.map(
                                  (item) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  )
                                )
                              ) : (
                                <option value={''} disabled>
                                  No hay datos registrados
                                </option>
                              )}
                            </>
                          </select>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {cols_search_div ? (
                  <div className={cols_search_div}>
                    <div className="row">
                      {!hideFilterBar && (
                        <div className={cols_search}>
                          {filter && filterLabelText && (
                            <label style={{ visibility: 'hidden' }}>hide</label>
                          )}
                          <input
                            id="searchBar"
                            type="text"
                            className="input-field form-control position-searchInput"
                            placeholder={
                              FilterBarPlaceholder
                                ? FilterBarPlaceholder
                                : 'Buscar...'
                            }
                            onChange={debounce(handleSearch, 300)}
                            defaultValue={filterBarValue ?? ''}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <>
                    {!hideFilterBar && (
                      <div className={cols_search}>
                        {filter && filterLabelText && (
                          <label style={{ visibility: 'hidden' }}>hide</label>
                        )}
                        <input
                          id="searchBar"
                          type="text"
                          className="input-field form-control position-searchInput"
                          placeholder={
                            FilterBarPlaceholder
                              ? FilterBarPlaceholder
                              : 'Buscar...'
                          }
                          onChange={debounce(handleSearch, 300)}
                          defaultValue={filterBarValue ?? ''}
                        />
                      </div>
                    )}
                  </>
                )}

                {cols_filters_div ? (
                  <div className={cols_filters_div}>
                    <div className="row">
                      {isFilterRangeShow && (
                        <>
                          {filterRangeProps?.from && (
                            <div className={cols_filters}>
                              {filterRangeProps?.from?.label && (
                                <label htmlFor={filterRangeProps?.from?.id}>
                                  {filterRangeProps?.from?.label ?? 'De:'}
                                </label>
                              )}
                              <DatePickerInput
                                id={filterRangeProps?.from?.id}
                                name="filterRangeDateFrom"
                                type="date"
                                className="input-field form-control position-searchInput"
                                onChange={(e) =>
                                  filterRangeProps?.changeFilterDateRange(
                                    e,
                                    'from'
                                  )
                                }
                                value={filterRangeProps?.from?.value ?? ''}
                                defaultValue={
                                  filterRangeProps?.from?.value ?? ''
                                }
                              />
                              {/* <input
                                id={filterRangeProps?.from?.id}
                                name="filterRangeDateFrom"
                                type="date"
                                className="input-field form-control position-searchInput"
                                onChange={(e) =>
                                  filterRangeProps?.changeFilterDateRange(
                                    e,
                                    'from'
                                  )
                                }
                                value={filterRangeProps?.from?.value ?? ''}
                                defaultValue={
                                  filterRangeProps?.from?.value ?? ''
                                }
                              /> */}
                            </div>
                          )}
                          {filterRangeProps?.to && (
                            <div className={cols_filters}>
                              {filterRangeProps?.to?.label && (
                                <label htmlFor={filterRangeProps?.to?.id}>
                                  {filterRangeProps?.to?.label ?? 'Hasta:'}
                                </label>
                              )}
                              <DatePickerInput
                                id={filterRangeProps?.to?.id}
                                name="filterRangeDateTo"
                                type="date"
                                className="input-field form-control position-searchInput"
                                onChange={(e) =>
                                  filterRangeProps?.changeFilterDateRange(
                                    e,
                                    'to'
                                  )
                                }
                                value={filterRangeProps?.to?.value ?? ''}
                                defaultValue={filterRangeProps?.to?.value ?? ''}
                              />

                              {/* <input
                                id={filterRangeProps?.to?.id}
                                name="filterRangeDateTo"
                                type="date"
                                className="input-field form-control position-searchInput"
                                onChange={(e) =>
                                  filterRangeProps?.changeFilterDateRange(
                                    e,
                                    'to'
                                  )
                                }
                                value={filterRangeProps?.to?.value ?? ''}
                                defaultValue={filterRangeProps?.to?.value ?? ''}
                              /> */}
                            </div>
                          )}
                        </>
                      )}
                      {filter &&
                        handleFilterSelect({
                          typeSelect: filterTypeSelect,
                          nameFilter: 'filter',
                        })}
                      {filterSecond &&
                        handleFilterSelect({
                          typeSelect: filterTypeSelectSecond,
                          nameFilter: 'filterSecond',
                        })}

                      {filterThird &&
                        handleFilterSelect({
                          typeSelect: filterTypeSelectThird,
                          nameFilter: 'filterThird',
                        })}

                      {filterFourth &&
                        handleFilterSelect({
                          typeSelect: filterTypeSelectFourth,
                          nameFilter: 'filterFourth',
                        })}

                      {filterFifth &&
                        handleFilterSelect({
                          typeSelect: filterTypeSelectFifth,
                          nameFilter: 'filterFifth',
                        })}

                      {filterSix &&
                        handleFilterSelect({
                          typeSelect: filterTypeSelectSix,
                          nameFilter: 'filterSix',
                        })}
                      {filterChoosen &&
                        filterChoosen.map(
                          (filter, index) =>
                            !filter.condition && (
                              // <div
                              //   className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
                              //   style={{
                              //     zIndex: 2,
                              //     marginTop: '0px',
                              //   }}
                              // >
                              <div
                                className={`${
                                  filter.classNameFull
                                    ? `${filter.classNameFull} `
                                    : `${cols_filters}`
                                }`}
                                key={index}
                              >
                                <Select
                                  id={filter.id}
                                  name={filter.name}
                                  // className={
                                  //   (filter.classNameFull
                                  //     ? `${filter.classNameFull} `
                                  //     : `${cols_filters}`) + `${filter.className}`
                                  // }
                                  placeholder={filter.placeholder}
                                  noOptionsMessage={filter.noOptionsMessage}
                                  options={filter.options}
                                  onBlur={filter.onBlur}
                                  onChange={filter.onChange}
                                  filterOption={filter.filterOption}
                                  isMulti={filter.isMulti}
                                  isClearable={filter.isClearable}
                                  isSearchable={filter.isSearchable}
                                  isDisabled={filter.isDisabled}
                                  isOptionDisabled={filter.isOptionDisabled}
                                  styles={filter.styles}
                                  readOnly={filter.readOnly}
                                  isLoading={filter.isLoading}
                                  onKeyDown={filter.onKeyDown}
                                  menuPosition={filter.menuPosition}
                                  value={
                                    filter.value !== null
                                      ? filter.options.find((option) => {
                                          if (filter.value === option.value) {
                                            return option
                                          }
                                          return null
                                        })
                                      : filter.defaultValue
                                  }
                                  menuIsOpen={filter.menuIsOpen}
                                  onInputChange={filter.onInputChange}
                                  getOptionLabel={filter.getOptionLabel}
                                  getOptionValue={filter.getOptionValue}
                                  // value = {}
                                />
                                {/* // </div> */}
                              </div>
                            )
                        )}
                    </div>
                  </div>
                ) : (
                  <>
                    {isFilterRangeShow && (
                      <>
                        {filterRangeProps?.from && (
                          <div className={cols_filters}>
                            <span htmlFor={filterRangeProps?.from?.id}>
                              {filterRangeProps?.from?.label ?? 'De:'}
                            </span>
                            <input
                              id={filterRangeProps?.from?.id}
                              name="filterRangeDateFrom"
                              type="date"
                              className="input-field form-control position-searchInput"
                              onChange={(e) =>
                                filterRangeProps?.changeFilterDateRange(
                                  e,
                                  'from'
                                )
                              }
                              value={filterRangeProps?.from?.value ?? ''}
                              defaultValue={filterRangeProps?.from?.value ?? ''}
                            />
                          </div>
                        )}
                        {filterRangeProps?.to && (
                          <div className={cols_filters}>
                            <span htmlFor={filterRangeProps?.to?.id}>
                              {filterRangeProps?.to?.label ?? 'Hasta:'}
                            </span>
                            <input
                              id={filterRangeProps?.to?.id}
                              name="filterRangeDateTo"
                              type="date"
                              className="input-field form-control position-searchInput"
                              onChange={(e) =>
                                filterRangeProps?.changeFilterDateRange(e, 'to')
                              }
                              value={filterRangeProps?.to?.value ?? ''}
                              defaultValue={filterRangeProps?.to?.value ?? ''}
                            />
                          </div>
                        )}
                      </>
                    )}
                    {filter && (
                      <div className={cols_filters}>
                        {filterLabelText && (
                          <label htmlFor="filter">{filterLabelText}</label>
                        )}
                        <select
                          id="filter"
                          name="filter"
                          type="select"
                          className="input-field form-control position-searchInput"
                          placeholder="Selecciona una opción"
                          onChange={filterOnChange}
                          defaultValue={
                            defaultValueSelect ? defaultValueSelect : ''
                          }
                        >
                          <option
                            value=""
                            readOnly={defaultValueSelect}
                            disabled={defaultValueSelect}
                          >
                            {filterDefaultOptionText
                              ? filterDefaultOptionText
                              : 'Todos'}
                          </option>
                          {filterOptions.map((option) => option)}
                        </select>
                      </div>
                    )}
                    {filterSecond && (
                      <div className={cols_filters}>
                        {filterLabelTextSecond && (
                          <label htmlFor="filterSecond">
                            {filterLabelTextSecond}
                          </label>
                        )}
                        <select
                          id="filterSecond"
                          name="filterSecond"
                          type="select"
                          className="input-field form-control position-searchInput"
                          placeholder="Selecciona una opción"
                          onChange={filterOnChangeSecond}
                          defaultValue={
                            defaultValueSelectSecond
                              ? defaultValueSelectSecond
                              : ''
                          }
                        >
                          <option
                            value=""
                            readOnly={defaultValueSelectSecond}
                            disabled={defaultValueSelectSecond}
                          >
                            {filterDefaultOptionTextSecond
                              ? filterDefaultOptionTextSecond
                              : 'Todos'}
                          </option>
                          {filterOptionsSecond.map((option) => option)}
                        </select>
                      </div>
                    )}

                    {filterThird && (
                      <div className={cols_filters}>
                        {filterLabelTextThird && (
                          <label htmlFor="filterThird">
                            {filterLabelTextThird}
                          </label>
                        )}
                        <select
                          id="filterThird"
                          name="filterThird"
                          type="select"
                          className="input-field form-control position-searchInput"
                          placeholder="Selecciona una opción"
                          onChange={filterOnChangeThird}
                          defaultValue={
                            defaultValueSelectThird
                              ? defaultValueSelectThird
                              : ''
                          }
                        >
                          <option
                            value=""
                            readOnly={defaultValueSelectThird}
                            disabled={defaultValueSelectThird}
                          >
                            {filterDefaultOptionTextThird
                              ? filterDefaultOptionTextThird
                              : 'Todos'}
                          </option>
                          {filterOptionsThird.map((option) => option)}
                        </select>
                      </div>
                    )}

                    {filterFourth && (
                      <div className={cols_filters}>
                        {filterLabelTextFourth && (
                          <label htmlFor="filterFourth">
                            {filterLabelTextFourth}
                          </label>
                        )}
                        <select
                          id="filterFourth"
                          name="filterFourth"
                          type="select"
                          className="input-field form-control position-searchInput"
                          placeholder="Selecciona una opción"
                          onChange={filterOnChangeFourth}
                          defaultValue={
                            defaultValueSelectFourth
                              ? defaultValueSelectFourth
                              : ''
                          }
                        >
                          <option
                            value=""
                            readOnly={defaultValueSelectFourth}
                            disabled={defaultValueSelectFourth}
                          >
                            {filterDefaultOptionTextFourth
                              ? filterDefaultOptionTextFourth
                              : 'Todos'}
                          </option>
                          {filterOptionsFourth.map((option) => option)}
                        </select>
                      </div>
                    )}

                    {filterFifth && (
                      <div className={cols_filters}>
                        {filterLabelTextFifth && (
                          <label htmlFor="filterFifth">
                            {filterLabelTextFifth}
                          </label>
                        )}
                        <select
                          id="filterFifth"
                          name="filterFifth"
                          type="select"
                          className="input-field form-control position-searchInput"
                          placeholder="Selecciona una opción"
                          onChange={filterOnChangeFifth}
                          defaultValue={
                            defaultValueSelectFifth
                              ? defaultValueSelectFifth
                              : ''
                          }
                        >
                          <option
                            value=""
                            readOnly={defaultValueSelectFifth}
                            disabled={defaultValueSelectFifth}
                          >
                            {filterDefaultOptionTextFifth
                              ? filterDefaultOptionTextFifth
                              : 'Todos'}
                          </option>
                          {filterOptionsFifth.map((option) => option)}
                        </select>
                      </div>
                    )}

                    {filterChoosen &&
                      filterChoosen.map(
                        (filter, index) =>
                          !filter.condition && (
                            // <div
                            //   className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
                            //   style={{
                            //     zIndex: 2,
                            //     marginTop: '0px',
                            //   }}
                            // >
                            <div
                              className={`${
                                filter.classNameFull
                                  ? `${filter.classNameFull} `
                                  : `${cols_filters}`
                              }`}
                              key={index}
                            >
                              <Select
                                id={filter.id}
                                name={filter.name}
                                // className={
                                //   (filter.classNameFull
                                //     ? `${filter.classNameFull} `
                                //     : `${cols_filters}`) + `${filter.className}`
                                // }
                                placeholder={filter.placeholder}
                                noOptionsMessage={filter.noOptionsMessage}
                                options={filter.options}
                                onBlur={filter.onBlur}
                                onChange={filter.onChange}
                                filterOption={filter.filterOption}
                                isMulti={filter.isMulti}
                                isClearable={filter.isClearable}
                                isSearchable={filter.isSearchable}
                                isDisabled={filter.isDisabled}
                                isOptionDisabled={filter.isOptionDisabled}
                                styles={filter.styles}
                                readOnly={filter.readOnly}
                                isLoading={filter.isLoading}
                                onKeyDown={filter.onKeyDown}
                                menuPosition={filter.menuPosition}
                                value={
                                  filter.value !== null
                                    ? filter.options.find((option) => {
                                        if (filter.value === option.value) {
                                          return option
                                        }
                                        return null
                                      })
                                    : filter.defaultValue
                                }
                                menuIsOpen={filter.menuIsOpen}
                                onInputChange={filter.onInputChange}
                                getOptionLabel={filter.getOptionLabel}
                                getOptionValue={filter.getOptionValue}
                                // value = {}
                              />
                              {/* // </div> */}
                            </div>
                          )
                      )}
                  </>
                )}

                {filterOnChangeDate && (
                  <div className={cols_filters}>
                    {filterLabelTextSecond && (
                      <label htmlFor="filterDate">{filterLabelDate}</label>
                    )}
                    <input
                      id="filterDate"
                      name="filterDate"
                      type="date"
                      className="input-field form-control position-searchInput"
                      onChange={filterOnChangeDate}
                      defaultValue={new Date()}
                      min={disableDates()}
                    />
                  </div>
                )}
                {customHeaderComponent && customHeaderComponent}
              </div>
            }
            conditionalRowStyles={conditionalRowStyles}
            paginationServer={paginationServer}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationTotalRows={totalCount}
            noDataComponent={noDataComponent}
            progressPending={loadingData}
            progressComponent={<Loader />}
            dense={dense}
            selectableRows={selectableRows}
            selectableRowsNoSelectAll={selectableRowsNoSelectAll}
            selectableRowsHighlight={selectableRows}
            onSelectedRowsChange={onSelectedRowsChange}
            selectableRowsVisibleOnly={selectableRowsVisibleOnly}
            paginationServerOptions={{
              persistSelectedOnPageChange: true,
              persistSelectedOnSort: true,
            }}
            selectableRowSelected={selectableRowSelected}
            selectableRowsComponent={selectableRowsComponent}
            selectableRowsComponentProps={selectableRowsComponentProps}
            selectableRowDisabled={rowDisabledCriteria}
            clearSelectedRows={clearSelectedRows}
            // onRowClicked={onRowClicked}
            // onRowDoubleClicked={onRowDoubleClicked}
          />
        </div>
      </div>
    </div>
  )
}
export default LayoutTable
